import BigNumber from 'bignumber.js';

export interface TransactionInfoTax {
	id: string;
	saleAmount: BigNumber;
	refundableAmount: BigNumber;
	refundableAmountLessTax: BigNumber;
	createdOn: string;
	tax: {
		rate: BigNumber;
		status: string;
		selectedExempt: boolean;
		amount: BigNumber;
		taxableSubtotal: BigNumber;
	};
}

export const defaultTransactionInfoTax: TransactionInfoTax = {
	id: '',
	saleAmount: BigNumber(0),
	refundableAmount: BigNumber(0),
	refundableAmountLessTax: BigNumber(0),
	createdOn: '',
	tax: {
		rate: BigNumber(0),
		status: '',
		selectedExempt: false,
		amount: BigNumber(0),
		taxableSubtotal: BigNumber(0),
	},
};
